module.exports = __webpack_public_path__ + "img/tu02.1ae09d60.png";